module.exports = __webpack_public_path__ + "img/liangaimin.b05ca9b2.png";